// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"qdeGj","content":"tZrbs","buttonMoreContent":"_2lMw6","labelImage":"CYdqS","image":"_2izoz"};